/** 线上绿绒酒馆三里屯店 A 桌「测试月赛」，样板间只认这一场 */
export const showroomGameId = 'ef6d57e3-0d5a-4db1-88e6-ff8d241dffc5'

export const demoEnvironmentNotice =
  '演示环境 / 所有订单、积分、座位及活动数据均为模拟数据，不产生真实交易与权益。'

export function isShowroomGame(gameId: string) {
  return gameId === showroomGameId
}

/** 样板间时钟对外永远显示「已进行这么久」 */
export const showroomClockElapsedMinutes = 10
/** 到点后把开始时间拨回，重新变成进行中 10 分钟 */
export const showroomResetIntervalMinutes = 60
/** 进入样板间赛事的会员每人只发一次 */
export const showroomWelcomePoints = 500

export const showroomClockElapsedMs = showroomClockElapsedMinutes * 60 * 1000
export const showroomResetIntervalMs = showroomResetIntervalMinutes * 60 * 1000

export function showroomStartedAt(now: Date): Date {
  return new Date(now.getTime() - showroomClockElapsedMs)
}

/** 开始时间已经走过「展示 10 分钟 + 间隔 1 小时」就该拨回 */
export function shouldResetShowroomClock(startedAt: Date, now: Date): boolean {
  return (
    now.getTime() - startedAt.getTime() >=
    showroomClockElapsedMs + showroomResetIntervalMs
  )
}

export function showroomWelcomeTicketKey(tenantId: string, memberId: string) {
  return `showroom-welcome-ticket:${tenantId}:${memberId}`
}

export function showroomWelcomePointsKey(tenantId: string, memberId: string) {
  return `showroom-welcome-points:${tenantId}:${memberId}`
}
